export default __webpack_public_path__ + "static/media/gerald1.e9043e0c.jpg";